export const STATI_PREV = {
  bozza: { label: "Bozza", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  inviato: { label: "Inviato", cls: "bg-sky-100 text-sky-700 border-sky-200" },
  accettato: { label: "Accettato", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  ordine: { label: "Ordine confermato", cls: "bg-violet-100 text-violet-700 border-violet-200" },
  rifiutato: { label: "Rifiutato", cls: "bg-red-100 text-red-700 border-red-200" },
  scaduto: { label: "Scaduto", cls: "bg-amber-100 text-amber-700 border-amber-200" },
};
export const TIPI_MANODOPERA = { officina: "Officina", cantiere: "Cantiere", trasferta: "Trasferta" };
export const TIPI_PREVENTIVO = { privato: "Privato", general_contractor: "General contractor", appalto_pubblico: "Appalto pubblico" };
const n = (v) => Number(v) || 0;

export const RIGA_VUOTA = () => ({ codice: "", origine: "aziendale", descrizione: "", um: "", quantita: "", misurazioni: [], prezzo_prezzario: 0, prezzo_offerto: "", costo_aziendale: "", costo_manuale: false, analisi: { materiali: [], manodopera: [], lavorazioni_esterne: [], trattamenti: [], trasporti: [] } });

export const costoPerKg = (m) => m.unita_prezzo === "kg" && m.um !== "kg" && n(m.peso_unitario) > 0;
export const importoMateriale = (m) => (costoPerKg(m) ? n(m.quantita) * n(m.peso_unitario) : n(m.quantita)) * n(m.costo_unitario);
export const totaleAnalisi = (an) => {
  if (!an) return 0;
  return an.materiali.reduce((s, m) => s + importoMateriale(m), 0) + an.manodopera.reduce((s, m) => s + n(m.ore) * n(m.tariffa), 0)
    + an.lavorazioni_esterne.reduce((s, m) => s + n(m.importo), 0) + an.trattamenti.reduce((s, m) => s + n(m.quantita) * n(m.costo), 0) + an.trasporti.reduce((s, m) => s + importoTrasporto(m), 0);
};
export const importoTrasporto = (m) => (m.unita ? n(m.quantita) * n(m.costo) : n(m.importo));
export const quantitaRiga = (r) => (r.misurazioni?.length ? r.misurazioni.reduce((s, m) => s + n(m.quantita), 0) : n(r.quantita));
export const analisiUnitaria = (an, q) => {
  const d = Number(q) || 1;
  const s = (v) => Math.round((n(v) / d) * 10000) / 10000;
  return { materiali: (an?.materiali || []).map((m) => ({ ...m, quantita: s(m.quantita) })), manodopera: (an?.manodopera || []).map((m) => ({ ...m, ore: s(m.ore) })),
    lavorazioni_esterne: (an?.lavorazioni_esterne || []).map((m) => ({ ...m, importo: s(m.importo) })), trattamenti: (an?.trattamenti || []).map((m) => ({ ...m, quantita: s(m.quantita) })),
    trasporti: (an?.trasporti || []).map((m) => ({ ...m, importo: s(m.importo) })) };
};
export const costoRiga = (r) => { if (r.costo_manuale) return n(r.costo_aziendale); const q = quantitaRiga(r); const t = totaleAnalisi(r.analisi); return q ? t / q : t; };
export const pesoMateriali = (an) => (an?.materiali || []).reduce((s, m) => s + (m.um === "kg" ? n(m.quantita) : m.peso_unitario != null ? n(m.quantita) * n(m.peso_unitario) : 0), 0);

// Stesse regole del backend (calcola_totali) per l'anteprima live
export const calcolaTotali = (p) => {
  const ribG = p.tipo !== "privato" ? n(p.ribasso) : 0;
  let offerto = 0, costo = 0, perdita = 0;
  const capitoli = p.capitoli.map((c) => {
    const rib = p.tipo !== "privato" && c.ribasso !== null && c.ribasso !== "" && c.ribasso !== undefined ? n(c.ribasso) : ribG;
    let so = 0, sc = 0;
    const righe = c.righe.map((r) => {
      const q = quantitaRiga(r), cu = costoRiga(r), io = q * n(r.prezzo_offerto), ic = q ? q * cu : cu;
      const ricon = rib && n(r.prezzo_prezzario) ? n(r.prezzo_prezzario) * (1 - rib / 100) : null;
      const inPerdita = ricon !== null && ricon < cu;
      if (inPerdita) perdita += 1;
      so += io; sc += ic;
      return { q, cu, io, ic, margine: io - ic, margine_perc: io ? ((io - ic) / io) * 100 : 0, ricon, inPerdita, rib };
    });
    offerto += so; costo += sc;
    return { rib, so, sc, righe };
  });
  const comuni = p.costi_comuni.reduce((s, c) => s + n(c.importo), 0);
  const iva = (offerto * n(p.iva)) / 100, costoTot = costo + comuni;
  return { capitoli, offerto, iva, totale: offerto + iva, costo_righe: costo, costi_comuni: comuni, costo: costoTot, margine: offerto - costoTot, margine_perc: offerto ? ((offerto - costoTot) / offerto) * 100 : 0, perdita };
};
